import React from 'react';
import man1 from '../../assets/img/man1.png';
import bgImg from '../../assets/img/map_pattern.png';
import FaqAccordion from '../FaqAccordion';

function Faq() {
    return (
      <section className="faq-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-12 d-flex justify-content-center">
              <div className="content-block">
                <p>Get Answers</p>
                <h1>Frequently Asked Questions</h1>
                <div className="bg-img">
                  <img src={bgImg} alt="" />
                  <div
                    className="man bg-cover man-1"
                    style={{
                      backgroundImage: `url(${man1})`,
                    }}
                  />
                  <div
                    className="man bg-cover man-2"
                    style={{
                      backgroundImage: `url(${man1})`,
                    }}
                  />
                  <div
                    className="man bg-cover man-3"
                    style={{
                      backgroundImage: `url(${man1})`,
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-12 mt-4 mt-xl-0">
              <div className="faq-content">
                <FaqAccordion
                  question=" Do you support new product development?"
                  answer="Yes, we support product development from drawing stage to mass production."
                />
                <FaqAccordion
                  question=" Do you provide third party inspection?"
                  answer="Yes, we provide third party inspection and quality audit services."
                />
                <FaqAccordion
                  question="What manufacturing processes do you support?"
                  answer="We support forging, machining, fasteners, sheet metal, extrusion, surface treatment, welding, laser cutting, moulding and fabrication."
                />
                <FaqAccordion
                  question=" Do you support prototype and small batch quantity?"
                  answer="Yes, we support prototype development, small batch production, and mass production."
                />
                {/* <FaqAccordion
                                question="Appropriately Communicate One-To-One Technology?"
                                answer="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec rhoncus dolor at libero ultricies ullamcorper vel ut dui. Maecenas sollicitudin risus non faucibus blandit. Nulla facilisi."
                            /> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
}

export default Faq;
